// React
import React from 'react';

// Internal
import { TODO } from '../types';

// Styles
import styles from './Typography.module.scss';

// MISC
import { get } from 'lodash-es';

interface TypographyProps {
  children: React.ReactNode;
  className?: string;
  color?: 'regular' | 'primary' | 'secondary';
  style?: Record<string, unknown>;
  type:
    | 'text_xl'
    | 'text_lg'
    | 'text_md'
    | 'text_sm'
    | 'text_xs'
    | 'display_2xl'
    | 'display_xl'
    | 'display_lg'
    | 'display_md'
    | 'display_sm'
    | 'display_xs';
  weight?: 'regular' | 'medium' | 'semibold' | 'bold';
}

export default function Typography(props: TypographyProps) {
  const { color, children, style: styleProp, type, weight } = props;

  const extraProps = {
    className: [
      color ? styles[`color-${color}`] : '',
      type.includes('text') ? styles[type.replace('_', '-')] : '',
    ].join(' '),
    style: {
      ...styleProp,
      fontWeight: get({ regular: 400, medium: 500, semibold: 600, bold: 700 }, weight || ''),
      lineHeight: 1.5,
    },
  };

  switch (type) {
    case 'text_xl':
    case 'text_lg':
    case 'text_md':
    case 'text_sm':
    case 'text_xs':
      return <p {...(extraProps as TODO)}>{children}</p>;
    case 'display_2xl':
      return <h1 {...(extraProps as TODO)}>{children}</h1>;
    case 'display_xl':
      return <h2 {...(extraProps as TODO)}>{children}</h2>;
    case 'display_lg':
      return <h3 {...(extraProps as TODO)}>{children}</h3>;
    case 'display_md':
      return <h4 {...(extraProps as TODO)}>{children}</h4>;
    case 'display_sm':
      return <h5 {...(extraProps as TODO)}>{children}</h5>;
    case 'display_xs':
      return <h6 {...(extraProps as TODO)}>{children}</h6>;
  }

  return <p {...(extraProps as TODO)}>{children}</p>;
}
